import * as C from '../constants';
import img_error from '../images/error.svg';

export default function Error({message}) {

  return (
      <div className='is-center is-full-screen text-center'>
        <div className='pr-8 pl-8 pb-4 pt-4 round-1 bg-red'>
          <div className='text-center'>
            <img alt='' src={img_error} width={64} height={64}/>
          </div>
          <div className='mb-2'>
            {C.N_GENERAL_ERROR}
          </div>
          {message &&
          <div>
            <code className='c-red'>{message}</code>
          </div>
          }
        </div>
      </div>
  );
}
